/* Beneos Account Hub ("Your Library"): a sub-nav over the Cloud sections, rendered
   inside the shop under one Shopify header. The "Library" view hosts the faceted
   search browser (beneos-search.js, full public catalog + entitlement overlay); the
   account panels (Orders / Account / Membership) come through the Shopify App Proxy
   as JSON. Stateless: the proxy signs the customer id. */
(function () {
  var root = document.getElementById('beneos-my-library');
  if (!root) return;
  var proxyUrl = root.getAttribute('data-proxy-url') || '/apps/beneos/library';
  var accountUrl = root.getAttribute('data-account-url') || 'https://cloud.beneos-battlemaps.com/';
  var patreonUrl = root.getAttribute('data-patreon-url') || 'https://www.patreon.com/BeneosBattlemaps';
  var hiwUrl = root.getAttribute('data-howitworks-url') || '/pages/how-it-works';
  var discordUrl = root.getAttribute('data-discord-url') || 'https://discord.gg/R2yBH557Wk';
  // Uebersetzte Beschriftung. Erste Wahl ist das data-l-Attribut der Section,
  // zweite die Bruecke aus snippets/beneos-i18n.liquid, letzte der englische
  // Text im Aufruf. Die zweite Stufe ist neu: 25 Schluessel wurden hier zwar
  // abgefragt, von der Section aber nie geliefert und fielen still auf Englisch
  // zurueck, in allen 13 Sprachen.
  function T(k, d) {
    var s = (window.Beneos && window.Beneos.strings) || {};
    var v = (s[k] != null && s[k] !== '') ? s[k] : d;
    // Shopify maskiert Uebersetzungswerte zu HTML-Entitaeten, ausser der
    // Schluessel endet auf _html. Hier wird wieder Rohtext daraus.
    return String(v).replace(/&(amp|lt|gt|quot|#39);/g, function (m, e) {
      return { 'amp': '&', 'lt': '<', 'gt': '>', 'quot': '"', '#39': "'" }[e];
    });
  }
  function lkey(k) { return 'library.' + String(k).replace(/-/g, '_'); }
  function L(k, d) { return root.getAttribute('data-l-' + k) || T(lkey(k), d); }

  var libTab = root.querySelector('.ln-tab[data-view="library"]');
  var panelTabs = root.querySelectorAll('.ln-tab[data-panel]');
  var shopTab = root.querySelector('.ln-tab[data-panel="orders"]');
  var adminTab = root.querySelector('.ln-admin');
  if (!libTab) return; // logged-out state renders no nav

  var libHost = root.querySelector('[data-view-panel="library"]');
  var panels = {};
  root.querySelectorAll('[data-panel-view]').forEach(function (p) { panels[p.getAttribute('data-panel-view')] = p; });

  var DL = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M12 3v12m0 0l-4-4m4 4l4-4M5 21h14"/></svg>';

  function withParam(url, kv) { return url + (url.indexOf('?') === -1 ? '?' : '&') + kv; }
  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  /* ---------- state ---------- */
  var ordersLoaded = false, accountLoaded = false, memLoaded = false, connData = null;
  var ordersData = null; // cached shop purchases (fetched once for the tab badge, reused on open)
  var searchStarted = false;

  /* ---------- toast (orders ZIP) ---------- */
  var mt, mtTimer;
  function toast(msg) {
    if (!mt) {
      mt = document.createElement('div');
      mt.style.cssText = 'position:fixed;left:50%;bottom:74px;transform:translateX(-50%) translateY(16px);z-index:450;background:var(--bg-card);border:1px solid var(--gold);color:var(--ink);padding:11px 18px;border-radius:30px;font-size:13px;opacity:0;pointer-events:none;transition:opacity .25s,transform .25s;box-shadow:0 16px 40px oklch(0 0 0 / .5);';
      document.body.appendChild(mt);
    }
    mt.textContent = msg;
    requestAnimationFrame(function () { mt.style.opacity = '1'; mt.style.transform = 'translateX(-50%) translateY(0)'; });
    clearTimeout(mtTimer);
    mtTimer = setTimeout(function () { mt.style.opacity = '0'; mt.style.transform = 'translateX(-50%) translateY(16px)'; }, 2400);
  }

  /* ---------- download via signed Cloud URL (orders) ---------- */
  function triggerDownload(assetId, btn) {
    if (!assetId) { toast(L('install-info', 'Open the Beneos module in Foundry to install.')); return; }
    if (btn) btn.setAttribute('disabled', 'disabled');
    toast(L('dl-toast', 'Preparing your download...'));
    fetch(withParam(proxyUrl, 'resource=download&asset_id=' + encodeURIComponent(assetId)), { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) { if (j && j.result === 'OK' && j.url) { window.location.href = j.url; } if (btn) btn.removeAttribute('disabled'); })
      .catch(function () { if (btn) btn.removeAttribute('disabled'); });
  }

  /* ---------- search browser (Layer 1) ---------- */
  function startSearch() {
    if (searchStarted) return;
    var host = document.getElementById('beneos-library-browser');
    if (!host || !window.BeneosSearch || !window.BeneosDB) return;
    searchStarted = true;
    window.BeneosSearch.init(host, {
      proxyUrl: host.getAttribute('data-proxy-url') || proxyUrl,
      locale: host.getAttribute('data-locale') || 'en',
      patreonUrl: host.getAttribute('data-patreon-url') || patreonUrl,
      shopUrl: host.getAttribute('data-shop-url') || '/collections/battlemaps'
    });
  }

  /* ---------- patreon status strip (in the Library hero) ---------- */
  var stripLoaded = false;
  // the two Beneos Patreon campaigns; keys match the Cloud patreon_link campaign param
  var CAMPAIGNS = [
    { key: 'battlemap', name: 'Beneos Battlemaps', url: root.getAttribute('data-patreon-url-battlemaps') || 'https://www.patreon.com/BeneosBattlemaps' },
    { key: 'token', name: 'Beneos Creatures, Spells & Loot', url: root.getAttribute('data-patreon-url-tokens') || 'https://www.patreon.com/BeneosTokens' }
  ];
  var PATREON_GLYPH = '<svg class="pat-glyph" width="13" height="13" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M22.957 7.21c-.004-3.064-2.391-5.576-5.191-6.482-3.478-1.125-8.064-.962-11.384.604C2.357 3.231 1.093 7.391 1.046 11.54c-.039 3.411.302 12.396 5.369 12.46 3.765.047 4.326-4.804 6.068-7.141 1.24-1.662 2.836-2.132 4.801-2.618 3.376-.836 5.678-3.501 5.673-7.031Z"/></svg>';
  function campaignMap(d) {
    var camps = (d && d.campaigns) || [];
    var list = Array.isArray(camps) ? camps : Object.keys(camps).map(function (k) { var c = camps[k] || {}; if (!c.key) c.key = k; return c; });
    var by = {}; list.forEach(function (c) { if (c && c.key) by[c.key] = c; });
    return by;
  }
  function renderPatreonStrip(d) {
    var box = root.querySelector('[data-patreon-strip]');
    if (!box) return;
    var by = campaignMap(d);
    // Hand the battlemap-campaign state to the asset browser: it decides from
    // this whether the premium band greets a patron or pitches a membership.
    // Fires whenever the strip renders, which may be before or after the
    // browser has initialised; the setter tolerates both orders.
    if (window.BeneosSearch && window.BeneosSearch.setPatronState) {
      window.BeneosSearch.setPatronState({ battlemapActive: !!(by.battlemap && by.battlemap.active) });
    }
    var chips = CAMPAIGNS.map(function (base) {
      var c = by[base.key] || {};
      var on = !!c.active;
      var name = c.name || base.name;
      if (on) {
        return '<span class="pat-chip on">' + PATREON_GLYPH + '<span class="pat-name">' + escapeHtml(name) + '</span>' +
          '<span class="pat-state">' + escapeHtml(L('pat-active', 'Active')) + (c.tier ? ' · ' + escapeHtml(c.tier) : '') + '</span></span>';
      }
      return '<a class="pat-chip pat-join" href="' + escapeHtml(base.url) + '" target="_blank" rel="noopener" title="' + escapeHtml(L('pat-open', 'Open on Patreon')) + '">' +
        PATREON_GLYPH + '<span class="pat-name">' + escapeHtml(name) + '</span>' +
        '<span class="pat-state">' + escapeHtml(L('pat-inactive', 'Not connected')) + '</span></a>';
    }).join('');
    // Discoverability: only when NO Patreon account is linked to this login at all
    // (patreon_linked === false) do we surface the CTA — the logged-in email isn't a
    // recognised patron, so they may be pledging under a different email. Once a Patreon
    // account is linked (even if a campaign lapsed) the CTA is pointless, so it's hidden.
    var patreonLinked = !!(d && d.patreon_linked);
    var linkCta = !patreonLinked
      ? '<button type="button" class="pat-chip pat-linkcta" data-pat-link>' + PATREON_GLYPH +
        '<span class="pat-name">' + escapeHtml(L('pat-link', 'A patron under a different email? Link your account')) + '</span></button>'
      : '';
    box.innerHTML = chips + linkCta;
    var lc = box.querySelector('[data-pat-link]');
    if (lc) lc.addEventListener('click', function () { showPanel('membership'); history.replaceState(null, '', '#membership'); });
    box.hidden = false;
  }
  function loadPatreonStrip() {
    if (stripLoaded) return;
    stripLoaded = true;
    if (connData) { renderPatreonStrip(connData); maybeShowAdmin(connData); return; }
    fetch(withParam(proxyUrl, 'resource=connections'), { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) { if (j && j.result === 'OK' && j.data) { connData = j.data; renderPatreonStrip(j.data); maybeShowAdmin(j.data); } else { stripLoaded = false; } })
      .catch(function () { stripLoaded = false; });
  }

  /* ---------- admin handover (cloud admins only) ---------- */
  function maybeShowAdmin(d) {
    if (adminTab && d && d.is_admin) adminTab.style.display = '';
    if (d && d.is_admin) loadPersonaState();
  }
  if (adminTab) {
    adminTab.addEventListener('click', function () {
      adminTab.setAttribute('disabled', 'disabled');
      fetch(withParam(proxyUrl, 'resource=admin_bridge'), { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (j) { if (j && j.result === 'OK' && j.url) { window.location.href = j.url; } else { adminTab.removeAttribute('disabled'); } })
        .catch(function () { adminTab.removeAttribute('disabled'); });
    });
  }

  /* ---------- Plan §54.1 — admin persona switcher (storefront UI) ----------
     Lets the operator simulate "act as a tier-X patron" without needing a
     real test account. Two dropdowns (Battlemap campaign + Tokens campaign),
     mutually exclusive: setting one clears the other. Server keeps the
     persona_tier_id in $_SESSION and rewrites resolveStorefrontDownloads
     plus all can*-helpers via effectivelyAdmin(). */
  var personaHost  = root.querySelector('[data-persona-host]');
  var personaBanner= root.querySelector('[data-persona-banner]');
  var personaClear = root.querySelector('[data-persona-clear]');
  var personaPicks = root.querySelectorAll('[data-persona-pick]');
  var personaState = null;
  var personaBusy  = false;

  function populatePersonaSelect(select, tiers, activeId) {
    var campId = select.getAttribute('data-persona-pick');
    select.innerHTML = '';
    var placeholder = campId === '4957729' ? T('library.persona_battlemap', 'Battlemap persona') : T('library.persona_tokens', 'Tokens persona');
    var opt0 = document.createElement('option');
    opt0.value = '0';
    opt0.textContent = placeholder;
    select.appendChild(opt0);
    tiers.forEach(function (t) {
      if (String(t.campaign_id) !== campId) return;
      var o = document.createElement('option');
      o.value = String(t.id);
      o.textContent = String(t.name || '').replace(/^Beneos [^|]+\|\s*/, '');
      select.appendChild(o);
    });
    if (activeId && String(activeId) !== '0') {
      var hit = select.querySelector('option[value="' + activeId + '"]');
      if (hit) {
        select.value = String(activeId);
        select.classList.add('is-active');
      } else {
        select.value = '0';
        select.classList.remove('is-active');
      }
    } else {
      select.value = '0';
      select.classList.remove('is-active');
    }
  }

  function renderPersonaBanner() {
    // Plan §56.2 — banner is the visual contract that admin is NOT in full-view.
    // It must be impossible to miss and survive any reload.
    if (!personaBanner) return;
    if (!personaState || !personaState.persona_tier_id) {
      personaBanner.hidden = true;
      personaBanner.innerHTML = '';
      if (personaClear) personaClear.hidden = true;
      document.body.classList.remove('beneos-persona-on');
      return;
    }
    var nameRaw = personaState.persona_name || (T('library.tier', 'Tier') + ' ' + personaState.persona_tier_id);
    var name = nameRaw.replace(/^Beneos [^|]+\|\s*/, '');
    var camp = String(personaState.persona_campaign) === '6842404' ? T('library.camp_tokens', 'Tokens') : T('library.camp_battlemap', 'Battlemap');
    personaBanner.innerHTML =
      '<span class="lpb-label">Persona active</span>' +
      '<span class="lpb-name">' + escapeHtml(camp) + ' · ' + escapeHtml(name) + '</span>' +
      '<button type="button" class="lpb-clear" data-persona-banner-clear>× Exit persona view</button>';
    personaBanner.hidden = false;
    if (personaClear) personaClear.hidden = false;
    document.body.classList.add('beneos-persona-on');
    var bc = personaBanner.querySelector('[data-persona-banner-clear]');
    if (bc) bc.addEventListener('click', function () { setPersona(0); });
  }

  function applyPersonaState(state) {
    personaState = state || {};
    if (!personaHost) return;
    if (!state || !state.is_admin) { personaHost.hidden = true; return; }
    personaHost.hidden = false;
    var tiers = Array.isArray(state.available_tiers) ? state.available_tiers : [];
    var activeId = parseInt(state.persona_tier_id || 0, 10);
    Array.prototype.forEach.call(personaPicks, function (sel) {
      populatePersonaSelect(sel, tiers, activeId);
    });
    renderPersonaBanner();
  }

  function setPersona(tierId) {
    if (personaBusy) return;
    personaBusy = true;
    var form = new FormData();
    form.append('tier_id', String(tierId));
    fetch(withParam(proxyUrl, 'resource=persona_set'), { method: 'POST', body: form, credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        personaBusy = false;
        if (j && j.result === 'OK') {
          // Hard reload so resolveStorefrontDownloads, library cards and download
          // gates re-render under the new persona. Cheapest correctness path.
          window.location.reload();
        }
      })
      .catch(function () { personaBusy = false; });
  }

  function loadPersonaState() {
    if (!personaHost) return;
    fetch(withParam(proxyUrl, 'resource=persona_state'), { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) { if (j && j.result === 'OK' && j.data) applyPersonaState(j.data); })
      .catch(function () {});
  }

  Array.prototype.forEach.call(personaPicks, function (sel) {
    sel.addEventListener('change', function () {
      var v = parseInt(sel.value || '0', 10);
      // Mutual exclusion: clear the OTHER campaign's dropdown before flipping.
      Array.prototype.forEach.call(personaPicks, function (other) {
        if (other !== sel) { other.value = '0'; other.classList.remove('is-active'); }
      });
      setPersona(v);
    });
  });
  if (personaClear) personaClear.addEventListener('click', function () { setPersona(0); });

  /* ---------- view switching ---------- */
  function showLibrary() {
    if (libHost) libHost.classList.remove('is-hidden');
    Object.keys(panels).forEach(function (k) { panels[k].classList.add('is-hidden'); });
    Array.prototype.forEach.call(panelTabs, function (b) { b.classList.remove('on'); });
    libTab.classList.add('on');
    startSearch();
    loadPatreonStrip();
  }
  function showPanel(name) {
    if (libHost) libHost.classList.add('is-hidden');
    Object.keys(panels).forEach(function (k) { panels[k].classList.toggle('is-hidden', k !== name); });
    libTab.classList.remove('on');
    Array.prototype.forEach.call(panelTabs, function (b) { b.classList.toggle('on', b.getAttribute('data-panel') === name); });
    if (name === 'orders') { if (ordersData !== null) { renderOrders(ordersData); } else if (!ordersLoaded) { loadOrders(); } markShopSeen(); }
    if (name === 'account' && !accountLoaded) loadAccount();
    if (name === 'membership' && !memLoaded) loadMembership();
  }
  libTab.addEventListener('click', function () { showLibrary(); history.replaceState(null, '', '#library'); });
  Array.prototype.forEach.call(panelTabs, function (b) {
    b.addEventListener('click', function () { showPanel(b.getAttribute('data-panel')); history.replaceState(null, '', '#' + b.getAttribute('data-panel')); });
  });

  /* ---------- shop purchases ("Shop" tab) ---------- */
  var ordPanel = panels.orders;
  function ot(k, d) { return (ordPanel && ordPanel.getAttribute('data-t-' + k)) || T(lkey(k), d); }

  // Tab highlight: glow the Shop tab when the buyer owns purchases, and pulse it when
  // something new arrived since their last visit (signature = count|newestDate|newestOrder,
  // stored in localStorage and cleared when the tab is opened).
  function purchaseSig(list) {
    if (!list || !list.length) return '';
    var newest = '', num = '';
    list.forEach(function (r) {
      var d = String(r.purchase_date || ''); if (d > newest) newest = d;
      var n = String(r.order_number == null ? '' : r.order_number); if (n > num) num = n;
    });
    return list.length + '|' + newest + '|' + num;
  }
  function markShopTab(list) {
    if (!shopTab) return;
    var has = !!(list && list.length);
    shopTab.classList.toggle('has-shop', has);
    if (!has) { shopTab.classList.remove('has-new'); return; }
    var seen = ''; try { seen = localStorage.getItem('beneos_shop_seen') || ''; } catch (e) {}
    shopTab.classList.toggle('has-new', purchaseSig(list) !== seen);
  }
  function markShopSeen() {
    if (!ordersData) return;
    try { localStorage.setItem('beneos_shop_seen', purchaseSig(ordersData)); } catch (e) {}
    if (shopTab) shopTab.classList.remove('has-new');
  }

  function renderOrders(list) {
    var body = ordPanel.querySelector('[data-orders-body]');
    var status = ordPanel.querySelector('[data-orders-status]');
    if (status) status.style.display = 'none';
    markShopTab(list);
    var note = ordPanel.querySelector('[data-orders-installnote]');
    if (note) note.hidden = !(list && list.length);
    if (!list || !list.length) { body.innerHTML = '<p class="mylib-empty">' + escapeHtml(ot('empty', 'No purchases yet.')) + '</p>'; return; }
    // Group the owned packs by their granting order so the buyer sees each purchase with its
    // date, order number and total, then the pack(s) it unlocked with a one-click download.
    var byOrder = {}, order = [];
    list.forEach(function (r) {
      var key = String(r.order_number == null ? (r.purchase_date || '~') : r.order_number);
      if (!byOrder[key]) { byOrder[key] = { number: r.order_number, date: r.purchase_date, total: r.order_total, currency: r.currency, gift: (r.source === 'gift'), packs: [] }; order.push(key); }
      byOrder[key].packs.push(r);
    });
    var dlLabel = L('download', 'Download ZIP');
    var html = '<div class="shop-orders">';
    order.forEach(function (key) {
      var o = byOrder[key];
      var meta = [];
      if (o.date) meta.push(escapeHtml(o.date));
      // An admin grant has no Shopify order behind it, so order number and total
      // are both empty. Say what it is instead of rendering blanks.
      if (o.gift) {
        meta.push('<span class="so-gift">' + escapeHtml(ot('gift', 'Gift from Beneos')) + '</span>');
      } else {
        if (o.number != null && o.number !== '') meta.push('#' + escapeHtml(o.number));
        if (o.total) meta.push(escapeHtml(o.total) + (o.currency ? ' ' + escapeHtml(o.currency) : ''));
      }
      html += '<div class="shop-order"><div class="so-head">' + meta.join(' · ') + '</div>';
      o.packs.forEach(function (p) {
        var thumb = p.thumb ? '<img class="so-thumb" src="' + escapeHtml(p.thumb) + '" alt="" loading="lazy">' : '<div class="so-thumb so-thumb-ph"></div>';
        var nameHtml = p.pack_url
          ? '<a class="so-name" href="' + escapeHtml(p.pack_url) + '">' + escapeHtml(p.name) + '</a>'
          : '<span class="so-name">' + escapeHtml(p.name) + '</span>';
        var dl = '';
        if (p.download_path && p.type === 'battlemap') {
          // bm_download 302-redirects straight to a fresh signed ZIP URL, so a direct link works.
          dl = '<a class="licon so-dl" href="' + escapeHtml(proxyUrl + p.download_path) + '">' + DL + ' ' + escapeHtml(dlLabel) + '</a>';
        } else if (p.cloudId || p.asset_id) {
          // resource=download returns JSON {url}; go through triggerDownload to follow it.
          dl = '<button type="button" class="licon so-dl" data-zip="' + escapeHtml(p.cloudId || p.asset_id) + '">' + DL + ' ' + escapeHtml(dlLabel) + '</button>';
        }
        html += '<div class="so-pack">' + thumb +
          '<div class="so-info">' + nameHtml +
          (p.summary ? '<div class="so-sum">' + escapeHtml(p.summary) + '</div>' : '') +
          '</div>' + dl + '</div>';
      });
      html += '</div>';
    });
    html += '</div>';
    body.innerHTML = html;
    body.querySelectorAll('[data-zip]').forEach(function (b) { b.addEventListener('click', function () { triggerDownload(b.getAttribute('data-zip'), b); }); });
  }
  function loadOrders() {
    ordersLoaded = true;
    var status = ordPanel.querySelector('[data-orders-status]'); if (status) status.style.display = '';
    fetch(withParam(proxyUrl, 'resource=orders'), { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (!j || j.result !== 'OK' || !j.data) { if (status) status.textContent = ot('error', 'Error'); ordersLoaded = false; return; }
        ordersData = j.data.orders || [];
        renderOrders(ordersData);
        markShopSeen();
      })
      .catch(function () { if (status) status.textContent = ot('error', 'Error'); ordersLoaded = false; });
  }
  // Fetch purchases once on load so the Shop tab can glow before it is ever opened.
  (function initShopBadge() {
    fetch(withParam(proxyUrl, 'resource=orders'), { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) { if (j && j.result === 'OK' && j.data) { ordersData = j.data.orders || []; markShopTab(ordersData); } })
      .catch(function () {});
  })();

  /* ---------- account (profile + connections) ---------- */
  var acctPanel = panels.account;
  function at(k, d) { return (acctPanel && acctPanel.getAttribute('data-t-' + k)) || T(lkey(k), d); }
  function initials(name, email) {
    var n = (name || '').trim();
    if (n) { var p = n.split(/\s+/); return ((p[0] || '')[0] || '' + (p[1] ? p[1][0] : '')).toUpperCase() + (p[1] ? p[1][0].toUpperCase() : ''); }
    return ((email || 'B')[0] || 'B').toUpperCase();
  }
  function renderAccount(d) {
    connData = d;
    try { sessionStorage.setItem('beneos_acct_v1', JSON.stringify({ avatar_url: d.avatar_url || '', full_name: d.full_name || '' })); } catch (e) {}
    var body = acctPanel.querySelector('[data-acct-body]');
    var status = acctPanel.querySelector('[data-acct-status]'); if (status) status.style.display = 'none';
    var by = campaignMap(d);
    function setRow(t, desc, ctrl) { return '<div class="set-row"><div class="sr-l"><div class="sr-t">' + t + '</div>' + (desc ? '<div class="sr-d">' + desc + '</div>' : '') + '</div><div class="sr-r">' + ctrl + '</div></div>'; }
    var avatarHtml = d.avatar_url
      ? '<span class="sb-avatar"><img src="' + escapeHtml(d.avatar_url) + '" alt=""></span>'
      : '<span class="sb-avatar">' + escapeHtml(initials(d.full_name, d.email)) + '</span>';

    var secProfile = '<div class="set-section" data-set-sec="profile"><h2>' + escapeHtml(at('profile', 'Profile')) + '</h2><p class="sd">' + escapeHtml(at('profile-sub', 'How your account appears across Beneos.')) + '</p>' +
      setRow(escapeHtml(at('avatar', 'Avatar')), escapeHtml(at('avatar-sub', 'Used in your library and (soon) in the Foundry module.')), avatarHtml + '<button type="button" class="btn ghost sm" data-avatar-btn>' + escapeHtml(at('upload', 'Upload')) + '</button><input type="file" accept="image/*" data-avatar-file hidden>') +
      setRow(escapeHtml(at('name', 'Display name')), escapeHtml(at('name-sub', 'What we call you in the UI and on receipts.')), '<input class="input" data-pf-name value="' + escapeHtml(d.full_name || '') + '"><button type="button" class="btn primary sm" data-pf-save>' + escapeHtml(at('save', 'Save')) + '</button>') +
      '<div class="set-status" data-pf-status></div></div>';

    var secEmail = '<div class="set-section is-hidden" data-set-sec="email"><h2>' + escapeHtml(at('email-login', 'Email & login')) + '</h2><p class="sd">' + escapeHtml(at('email-sub', 'Used to sign in and receive receipts. Login is passwordless via Shopify.')) + '</p>' +
      setRow(escapeHtml(at('email', 'Email')), '', '<input class="input" type="email" data-em-email value="' + escapeHtml(d.email || '') + '"><button type="button" class="btn primary sm" data-em-save>' + escapeHtml(at('save', 'Save')) + '</button>') +
      '<div class="set-status" data-em-status></div></div>';

    var secDanger = '<div class="set-section is-hidden" data-set-sec="danger"><h2 class="danger-h">' + escapeHtml(at('danger', 'Danger zone')) + '</h2><p class="sd">' + escapeHtml(at('danger-sub', 'Irreversible actions.')) + '</p>' +
      setRow(escapeHtml(at('delete', 'Delete account')), escapeHtml(at('delete-sub', 'Removes your profile. Shop receipts are kept for tax records.')), '<button type="button" class="btn danger sm" data-delete-account>' + escapeHtml(at('delete-btn', 'Delete account')) + '</button>') + '</div>';

    var navItems = [['profile', at('profile', 'Profile')], ['email', at('email-login', 'Email & login')], ['danger', at('danger', 'Danger zone')]];
    var nav = navItems.map(function (s, i) { return '<a data-set-nav="' + s[0] + '"' + (i === 0 ? ' class="on"' : '') + '>' + escapeHtml(s[1]) + '</a>'; }).join('');

    body.innerHTML = '<div class="acct-settings"><div class="set-grid"><div class="set-side">' + nav + '</div><div class="set-main">' +
      secProfile + secEmail + secDanger + '</div></div></div>';
    wireSettings(body, d);
  }

  /* ---------- account settings wiring + actions ---------- */
  function wireSettings(body, d) {
    body.querySelectorAll('[data-set-nav]').forEach(function (a) {
      a.addEventListener('click', function () {
        var id = a.getAttribute('data-set-nav');
        body.querySelectorAll('[data-set-nav]').forEach(function (x) { x.classList.toggle('on', x === a); });
        body.querySelectorAll('[data-set-sec]').forEach(function (s) { s.classList.toggle('is-hidden', s.getAttribute('data-set-sec') !== id); });
      });
    });
    var pfSave = body.querySelector('[data-pf-save]');
    if (pfSave) pfSave.addEventListener('click', function () { saveProfile((body.querySelector('[data-pf-name]') || {}).value || '', d.email, body.querySelector('[data-pf-status]'), pfSave); });
    var emSave = body.querySelector('[data-em-save]');
    if (emSave) emSave.addEventListener('click', function () { saveProfile(d.full_name, (body.querySelector('[data-em-email]') || {}).value || '', body.querySelector('[data-em-status]'), emSave); });
    var avBtn = body.querySelector('[data-avatar-btn]'), avFile = body.querySelector('[data-avatar-file]');
    if (avBtn && avFile) { avBtn.addEventListener('click', function () { avFile.click(); }); avFile.addEventListener('change', function () { if (avFile.files && avFile.files[0]) uploadAvatar(avFile.files[0], avBtn); }); }
    var del = body.querySelector('[data-delete-account]'); if (del) del.addEventListener('click', function () { deleteAccount(del); });
  }
  function refreshAccount() { connData = null; accountLoaded = false; stripLoaded = false; loadAccount(); loadPatreonStrip(); }
  function saveProfile(name, email, st, btn) {
    if (btn) btn.setAttribute('disabled', 'disabled'); if (st) st.textContent = at('saving', 'Saving...');
    fetch(proxyUrl, { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, credentials: 'same-origin',
      body: 'action=update_profile&full_name=' + encodeURIComponent(name || '') + '&email=' + encodeURIComponent(email || '') })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (btn) btn.removeAttribute('disabled');
        if (j && j.result === 'OK') { if (st) st.textContent = j.shopify_saved ? at('saved', 'Saved') : at('saved-partial', 'Saved (shop sync pending)'); if (connData) { connData.full_name = name; connData.email = email; } }
        else if (j && j.information === 'invalid_email') { if (st) st.textContent = at('invalid-email', 'Invalid email'); }
        else { if (st) st.textContent = at('error', 'Error'); }
      })
      .catch(function () { if (btn) btn.removeAttribute('disabled'); if (st) st.textContent = at('error', 'Error'); });
  }
  function uploadAvatar(file, btn) {
    if (file.size > 4 * 1024 * 1024) { toast(at('avatar-toobig', 'Image too large (max 4 MB).')); return; }
    var old = btn.textContent; btn.setAttribute('disabled', 'disabled'); btn.textContent = at('uploading', 'Uploading...');
    var fd = new FormData(); fd.append('action', 'upload_avatar'); fd.append('avatar', file);
    fetch(proxyUrl, { method: 'POST', credentials: 'same-origin', body: fd })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        btn.removeAttribute('disabled'); btn.textContent = old;
        if (j && j.result === 'OK' && j.url) { if (connData) connData.avatar_url = j.url; refreshAccount(); toast(at('avatar-done', 'Avatar updated.')); }
        else { toast(at('soon', 'This will be available shortly.')); }
      })
      .catch(function () { btn.removeAttribute('disabled'); btn.textContent = old; toast(at('soon', 'This will be available shortly.')); });
  }
  function unlinkPatreon(campaign, btn) {
    btn.setAttribute('disabled', 'disabled');
    fetch(proxyUrl, { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, credentials: 'same-origin',
      body: 'action=unlink_patreon&campaign=' + encodeURIComponent(campaign) })
      .then(function (r) { return r.json(); })
      .then(function (j) { if (j && j.result === 'OK') { refreshAccount(); } else { btn.removeAttribute('disabled'); toast(at('soon', 'This will be available shortly.')); } })
      .catch(function () { btn.removeAttribute('disabled'); toast(at('soon', 'This will be available shortly.')); });
  }
  function revokeDevice(fid, btn) {
    btn.setAttribute('disabled', 'disabled');
    fetch(proxyUrl, { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, credentials: 'same-origin',
      body: 'action=revoke_device&foundry_id=' + encodeURIComponent(fid) })
      .then(function (r) { return r.json(); })
      .then(function (j) { if (j && j.result === 'OK') { accountLoaded = false; loadAccount(); } else { btn.removeAttribute('disabled'); } })
      .catch(function () { btn.removeAttribute('disabled'); });
  }
  function exportData(btn) {
    var old = btn.textContent; btn.setAttribute('disabled', 'disabled'); btn.textContent = at('preparing', 'Preparing...');
    fetch(withParam(proxyUrl, 'resource=export'), { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        btn.removeAttribute('disabled'); btn.textContent = old;
        if (j && j.result === 'OK' && j.data) { var blob = new Blob([JSON.stringify(j.data, null, 2)], { type: 'application/json' }); var url = URL.createObjectURL(blob); var a = document.createElement('a'); a.href = url; a.download = 'beneos-account.json'; document.body.appendChild(a); a.click(); a.remove(); URL.revokeObjectURL(url); }
        else { toast(at('soon', 'This will be available shortly.')); }
      })
      .catch(function () { btn.removeAttribute('disabled'); btn.textContent = old; toast(at('soon', 'This will be available shortly.')); });
  }
  function deleteAccount(btn) {
    if (!window.confirm(at('delete-confirm', 'Delete your Beneos account? This removes your profile and connections. Shop receipts are kept for tax records. This cannot be undone.'))) return;
    btn.setAttribute('disabled', 'disabled');
    fetch(proxyUrl, { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, credentials: 'same-origin', body: 'action=delete_account&confirm=1' })
      .then(function (r) { return r.json(); })
      .then(function (j) { if (j && j.result === 'OK') { window.location.href = '/'; } else { btn.removeAttribute('disabled'); toast(at('soon', 'This will be available shortly.')); } })
      .catch(function () { btn.removeAttribute('disabled'); toast(at('soon', 'This will be available shortly.')); });
  }
  function loadAccount() {
    accountLoaded = true;
    var status = acctPanel.querySelector('[data-acct-status]'); if (status) status.style.display = '';
    fetch(withParam(proxyUrl, 'resource=connections'), { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) { if (!j || j.result !== 'OK' || !j.data) { if (status) status.textContent = at('error', 'Error'); accountLoaded = false; return; } renderAccount(j.data); })
      .catch(function () { if (status) status.textContent = at('error', 'Error'); accountLoaded = false; });
  }

  function connectPatreon(btn, campaign) {
    if (btn) btn.setAttribute('disabled', 'disabled');
    var param = 'resource=patreon_link' + (campaign ? '&campaign=' + encodeURIComponent(campaign) : '');
    fetch(withParam(proxyUrl, param), { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (j && j.result === 'OK' && j.url) { window.top.location.href = j.url; return; }
        if (btn) btn.removeAttribute('disabled');
        toast(T('library.patreon_start_failed', 'Could not start the Patreon connection. Please try again in a moment.'));
      })
      .catch(function () { if (btn) btn.removeAttribute('disabled'); toast(T('library.server_unreachable', 'Could not reach the server. Please try again.')); });
  }

  /* ---------- membership ---------- */
  var memPanel = panels.membership;
  function mt2(k, d) { return (memPanel && memPanel.getAttribute('data-t-' + k)) || d; }
  function renderMembership(d) {
    var body = memPanel.querySelector('[data-mem-body]');
    var status = memPanel.querySelector('[data-mem-status]'); if (status) status.style.display = 'none';
    var html = '';
    // membership_active, NOT patreon_linked. patreon_linked only means "a Patreon
    // account is attached to this login" and stays true for someone who linked an
    // account Patreon has no membership for. Keying the hero off it announced an
    // "Active membership" to users who had none and could not download anything
    // (OP-CLD-087). Older cloud builds do not send the field: fall back to the
    // per-campaign flags the strip already uses, never to patreon_linked.
    var memberActive = d && (typeof d.membership_active !== 'undefined'
      ? !!d.membership_active
      : !!(d.campaigns || []).some(function (c) { return c && c.active; }));
    if (memberActive) {
      var meta = '';
      if (d.patreon_price) meta += '<div><div class="k">' + escapeHtml(mt2('price', 'Price')) + '</div><div class="v">' + escapeHtml(d.patreon_price) + '</div></div>';
      if (d.patreon_next_billing) meta += '<div><div class="k">' + escapeHtml(mt2('next', 'Next billing')) + '</div><div class="v">' + escapeHtml(d.patreon_next_billing) + '</div></div>';
      if (d.member_since) meta += '<div><div class="k">' + escapeHtml(mt2('since', 'Member since')) + '</div><div class="v">' + escapeHtml(d.member_since) + '</div></div>';
      html += '<div class="mem-hero">' +
        '<div class="mh-k">' + escapeHtml(mt2('active', 'Active membership')) + '</div>' +
        '<div class="mh-tier">' + escapeHtml(d.patreon_tier || mt2('default-tier', 'Patreon member')) + '</div>' +
        (d.patreon_tier_desc ? '<div class="mh-sub">' + escapeHtml(d.patreon_tier_desc) + '</div>' : '') +
        (meta ? '<div class="mh-meta">' + meta + '</div>' : '') +
        '</div>' +
        '<div class="mem-acts"><a class="btn ghost" href="' + escapeHtml(patreonUrl) + '" target="_blank" rel="noopener">' + escapeHtml(mt2('manage', 'Manage on Patreon')) + '</a>' +
        '<a class="btn ghost" href="' + escapeHtml(hiwUrl) + '#compare">' + escapeHtml(mt2('compare', 'Compare tiers')) + '</a></div>';
    } else {
      // One Patreon OAuth covers both Beneos campaigns (the callback reads every
      // membership from a single identity), so a single Connect button is enough.
      // It also links a Patreon account whose email differs from the shop login.
      // Two different situations share this branch, and telling them apart is the
      // whole point: nothing linked yet (offer the link), or linked but Patreon
      // reports no membership (do not offer the link again, it will not help).
      var linkedButNoMembership = !!(d && d.patreon_linked);
      html += '<div class="mem-hero"><div class="mh-k">' + escapeHtml(mt2('none', 'No active membership')) + '</div>';
      if (linkedButNoMembership) {
        html += '<div class="mh-sub">' + escapeHtml(mt2('linked-none-sub',
          'Your Patreon account is connected, but we do not see an active Beneos membership on it. '
          + 'If you just subscribed, this can take a few minutes. If it does not appear, check that you '
          + 'subscribed with this Patreon account, or contact us and we will look into it.')) + '</div>' +
          '<div class="mem-acts" style="margin-top:18px;"><a class="btn ghost" href="' + escapeHtml(patreonUrl) + '" target="_blank" rel="noopener">' + escapeHtml(mt2('manage', 'Manage on Patreon')) + '</a></div>';
      } else {
        html += '<div class="mh-sub">' + escapeHtml(mt2('none-sub', 'Link Patreon to unlock the full backlog and every monthly drop.')) + '</div>' +
          '<div class="mem-acts" style="margin-top:18px;"><button type="button" class="btn primary" data-patreon-connect data-campaign="battlemap">' + escapeHtml(mt2('connect', 'Connect Patreon')) + '</button></div>' +
          '<div class="mh-sub" style="margin-top:14px;">' + escapeHtml(mt2('connect-note', 'Link a Patreon account to this Beneos Cloud account, even if it uses a different email than your shop login and was not detected automatically. One link covers both Beneos campaigns.')) + '</div>';
      }
      html += '</div>';
    }
    body.innerHTML = html;
    body.querySelectorAll('[data-patreon-connect]').forEach(function (pc) { pc.addEventListener('click', function () { connectPatreon(pc, pc.getAttribute('data-campaign') || ''); }); });
  }
  function loadMembership() {
    memLoaded = true;
    if (connData) { renderMembership(connData); return; }
    var status = memPanel.querySelector('[data-mem-status]'); if (status) status.style.display = '';
    fetch(withParam(proxyUrl, 'resource=connections'), { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) { if (!j || j.result !== 'OK' || !j.data) { if (status) status.textContent = mt2('error', 'Error'); memLoaded = false; return; } connData = j.data; renderMembership(j.data); })
      .catch(function () { if (status) status.textContent = mt2('error', 'Error'); memLoaded = false; });
  }

  /* ---------- landing: honour hash, else library ---------- */
  var h = (location.hash || '').replace('#', '');
  if (panels[h]) { showPanel(h); }
  else { showLibrary(); }
  loadPatreonStrip();

  /* ---------- Patreon link result banner (Cloud OAuth redirects back here) ----------
     patreon_link_ok=1            linked
     patreon_link_ok=1&merged=1   linked + the auto-created patron account was merged in
     patreon_link_error=conflict  identity belongs to another, actively used account */
  (function () {
    var qs = new URLSearchParams(location.search);
    var msg = null, tone = 'ok';
    if (qs.get('patreon_link_ok') === '1') {
      // The cloud now reports whether the linked account actually carries a
      // membership. Announcing "your patron access is live" to someone Patreon has
      // no membership for is what sent them to support believing they had paid
      // and been locked out (OP-CLD-087).
      var membership = qs.get('membership');
      if (membership === 'none') {
        tone = 'warn';
        msg = L('pat-linked-nomember', 'Patreon account linked, but we do not see an active Beneos membership on it. '
          + 'If you just subscribed, this can take a few minutes. If it does not appear, check that you subscribed '
          + 'with this Patreon account, or contact us and we will look into it.');
      } else if (membership === 'unknown') {
        tone = 'warn';
        msg = L('pat-linked-pending', 'Patreon account linked. We could not confirm your membership with Patreon just now, it should appear within a few minutes.');
      } else {
        msg = qs.get('merged') === '1'
          ? L('pat-linked-merged', 'Patreon linked. We found an auto-created patron account for this Patreon identity and merged it into your account, so everything is in one place now.')
          : L('pat-linked-ok', 'Patreon account linked. Your patron access is live.');
      }
    } else if (qs.get('patreon_link_error')) {
      tone = 'err';
      msg = qs.get('patreon_link_error') === 'conflict'
        ? L('pat-link-conflict', 'This Patreon account is already linked to another Beneos account that is actively in use. Log in to that account instead, or contact support and we will merge them for you.')
        : L('pat-link-failed', 'Linking Patreon did not work. Please try again or contact support.');
    }
    if (!msg) return;
    var bar = document.createElement('div');
    bar.setAttribute('role', 'status');
    var toneCss = {
      ok:   'background:rgba(90,140,90,0.15);border:1px solid rgba(90,140,90,0.5);',
      warn: 'background:rgba(180,140,50,0.15);border:1px solid rgba(180,140,50,0.5);',
      err:  'background:rgba(170,70,50,0.15);border:1px solid rgba(170,70,50,0.5);'
    };
    bar.style.cssText = 'margin:0 0 1rem;padding:0.7rem 1rem;border-radius:0.4rem;font-size:0.92rem;'
      + (toneCss[tone] || toneCss.err);
    bar.textContent = msg;
    root.insertBefore(bar, root.firstChild);
    ['patreon_link_ok', 'patreon_link_error', 'merged', 'membership'].forEach(function (k) { qs.delete(k); });
    var clean = location.pathname + (qs.toString() ? '?' + qs.toString() : '') + location.hash;
    history.replaceState(null, '', clean);
  })();
})();
